import { SkinElement } from "../skin.js";
import { template } from "../../internal/skins/minimal-live-video/template.js";
import minimal_skin_default from "../../define/live-video/minimal-skin2.js";
import { createShadowStyle } from "@videojs/utils/dom";
//#region src/presets/live-video/minimal-skin.ts
/** Packaged Minimal live-video UI registered as `<live-video-minimal-skin>`. */
var MinimalLiveVideoSkinElement = class extends SkinElement {
	static {
		this.tagName = "live-video-minimal-skin";
	}
	static {
		this.styles = createShadowStyle(minimal_skin_default);
	}
	static {
		this.template = template;
	}
};
//#endregion
export { MinimalLiveVideoSkinElement };
